import React from 'react'

const Testimonial = () => {
  return (
    <div id="testimonial">
        <h2>Testimonial</h2>
        <section>
            <TestimonialCard 
            name={"hamza"}
            feedback={"you are quick learner."}
            /> 
            <TestimonialCard 
            name={"maaz"}
            feedback={"your programming skills are good."}
            />   

            <TestimonialCard 
            name={"wasif"}
            feedback={"your web development skills are wonderful."}
            />        
        </section>
        
        </div>
  );
};

const TestimonialCard =({name,feedback}) =>(
    <article>
        <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
         alt= "User" />
        <h4>{name}</h4>
        <p>{feedback}</p>
    </article>
)

export default Testimonial